import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import type { CandidateQuestionsModuleTranslations } from './translations';
import { CandidateQuestionsTranslations } from './translations';

@NgModule({
  imports: [MomentModule],
  exports: [],
})
export class CandidateQuestionsModule {
  public static withTranslations(
    translations: CandidateQuestionsModuleTranslations,
  ): ModuleWithProviders<CandidateQuestionsModule> {
    return {
      ngModule: CandidateQuestionsModule,
      providers: [{ provide: CandidateQuestionsTranslations, useValue: translations }],
    };
  }
}

export * from './candidate-questions.interfaces';
export * from './candidate-questions.component';
